import React from 'react';
import { ApolloProvider } from '@apollo/client';
import useDHApolloClient from './hooks/useDHApolloClient';

const AppSyncProvider = ({
  children,
}: {
  children: any;
}): JSX.Element | null => {
  const client = useDHApolloClient();

  if (!client) return null;

  return <ApolloProvider client={client}>{children}</ApolloProvider>;
};
export default AppSyncProvider;
